/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Body_Weight_OpenInputs */

const en_us2_progress_body_weight_open = /** @type {(inputs: Progress_Body_Weight_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log or correct it in your profile`)
};

const pt_br2_progress_body_weight_open = /** @type {(inputs: Progress_Body_Weight_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar ou corrigir no perfil`)
};

const es_419_progress_body_weight_open = /** @type {(inputs: Progress_Body_Weight_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regístralo o corrígelo en tu perfil`)
};

const pt_pt2_progress_body_weight_open = /** @type {(inputs: Progress_Body_Weight_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registar ou corrigir no perfil`)
};

const fr_fr2_progress_body_weight_open = /** @type {(inputs: Progress_Body_Weight_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'enregistrer ou le corriger dans ton profil`)
};

const de_de2_progress_body_weight_open = /** @type {(inputs: Progress_Body_Weight_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Profil eintragen oder korrigieren`)
};

const it_it2_progress_body_weight_open = /** @type {(inputs: Progress_Body_Weight_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registralo o correggilo nel profilo`)
};

/**
* | output |
* | --- |
* | "Log or correct it in your profile" |
*
* @param {Progress_Body_Weight_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_body_weight_open = /** @type {((inputs?: Progress_Body_Weight_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Body_Weight_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_body_weight_open(inputs)
	if (locale === "es-419") return es_419_progress_body_weight_open(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_body_weight_open(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_body_weight_open(inputs)
	if (locale === "de-DE") return de_de2_progress_body_weight_open(inputs)
	if (locale === "it-IT") return it_it2_progress_body_weight_open(inputs)
	return en_us2_progress_body_weight_open(inputs)
});
export { progress_body_weight_open as "progress.body_weight_open" }